import React, { useCallback, useEffect, useState } from "react";
import ArrowRightIcon from "@/assets/images/icons/left-arrow.svg";
import moment from "moment";
import "./style.scss";
import { Fields } from "../../uicomponents";
import get from "lodash/get";
import outsideClick from "../../hooks/OutsideClick";

const Index = ({
  canSetDefault,
  handleClick,
  initialDefault,
  dropdownPosition,
}) => {
  const { ref, isVisible, setIsVisible } = outsideClick();

  const initialValue = {
    type: initialDefault,
    startOf: moment()
      .startOf(initialDefault)
      .unix(),
    endOf: moment()
      .endOf(initialDefault)
      .unix(),
  };

  const [startValue, setStartValue] = useState(null);
  const [endValue, setEndValue] = useState(null);
  const [value, setValue] = useState(canSetDefault ? initialValue : null);

  useEffect(() => {
    if (value && value.startOf && value.endOf) {
      handleClick(value.startOf, value.endOf);
    }
  }, [value]);

  const changeHandler = (value) => {
    setValue(value);
  };
  const simpleFuncMoment = (typeDay, hasStart) => {
    return hasStart
      ? moment()
          .startOf(typeDay)
          .unix()
      : moment()
          .endOf(typeDay)
          .unix();
  };
  const subtractFuncMoment = (typeDays, hasStart) => {
    return hasStart
      ? moment()
          .subtract(1, typeDays)
          .startOf(typeDays)
          .unix()
      : moment()
          .subtract(1, typeDays)
          .endOf(typeDays)
          .unix();
  };

  const menuList = [
    {
      key: 1,
      onClick: () => {
        changeHandler({
          type: "day",
          startOf: moment()
            .startOf("day")
            .unix(),
          endOf: moment()
            .endOf("day")
            .unix(),
        });
      },
      title: "Сегодня",
    },
    {
      key: 9,
      onClick: () => {
        changeHandler({
          type: "day",
          startOf: moment()
            .subtract(1, "day")
            .startOf("day")
            .unix(),
          endOf: moment()
            .subtract(1, "day")
            .endOf("day")
            .unix(),
        });
      },
      title: "Вчера",
    },
    {
      key: 2,
      onClick: () => {
        changeHandler({
          type: "week",
          startOf: simpleFuncMoment("week", true),
          endOf: simpleFuncMoment("week", false),
        });
      },
      title: "Этa неделя",
    },
    {
      key: 3,
      title: "Этот месяц",
      onClick: () => {
        changeHandler({
          type: "months",
          startOf: simpleFuncMoment("month", true),
          endOf: simpleFuncMoment("month", false),
        });
      },
    },
    {
      key: 4,
      onClick: () => {
        changeHandler({
          type: "months",
          startOf: subtractFuncMoment("months", true),
          endOf: subtractFuncMoment("months", false),
        });
      },
      title: "Прошлый месяц",
    },
    {
      key: 5,
      onClick: () => {
        changeHandler({
          type: "quarters",
          startOf: simpleFuncMoment("quarter", true),
          endOf: simpleFuncMoment("quarter", false),
        });
      },
      title: "Этот квартал",
    },
    {
      key: 6,
      onClick: () => {
        changeHandler({
          type: "quarters",
          startOf: subtractFuncMoment("quarters", true),
          endOf: subtractFuncMoment("quarters", false),
        });
      },
      title: "Прошлый квартал",
    },
    {
      key: 7,
      title: "Этот год",
      onClick: () => {
        changeHandler({
          type: "years",
          startOf: simpleFuncMoment("year", true),
          endOf: simpleFuncMoment("year", false),
        });
      },
    },
    {
      key: 8,
      title: "Прошлый год",
      onClick: () => {
        changeHandler({
          type: "years",
          startOf: subtractFuncMoment("years", true),
          endOf: subtractFuncMoment("years", false),
        });
      },
    },
  ];

  const onStartChange = useCallback((value) => {
    setStartValue(value);
  }, []);

  const onEndChange = useCallback((value) => {
    setEndValue(value);
  }, []);

  const dateConvert = (value) => {
    if (get(value, "type") === "day") {
      return moment.unix(get(value, "startOf")).format("D MMM YYYY");
    } else if (get(value, "type") === "interval") {
      return `${
        get(value, "startOf")
          ? moment.unix(get(value, "startOf")).format("D MMM")
          : ""
      } ${
        get(value, "startOf")
          ? moment.unix(get(value, "startOf")).format("YYYY")
          : ""
      } ${get(value, "startOf") && get(value, "endOf") ? "-" : ""} ${
        get(value, "endOf")
          ? moment.unix(get(value, "endOf")).format("D MMM")
          : ""
      } ${
        get(value, "endOf")
          ? moment.unix(get(value, "endOf")).format("YYYY")
          : ""
      }`;
    } else {
      return `${
        get(value, "startOf")
          ? moment.unix(get(value, "startOf")).format("D MMM")
          : ""
      } ${get(value, "startOf") && get(value, "endOf") ? "-" : ""} ${
        get(value, "endOf")
          ? moment.unix(get(value, "endOf")).format("D MMM")
          : ""
      } ${moment.unix(get(value, "startOf")).format("YYYY")}`;
    }
  };

  const dynamicFunc = (value, count, type) => {
    if (type === "prev") {
      return {
        ...value,
        startOf: moment
          .unix(get(value, "startOf"))
          .subtract(count, `${get(value, "type")}`)
          .startOf()
          .unix(),
        endOf: moment
          .unix(get(value, "endOf"))
          .subtract(count, `${get(value, "type")}`)
          .endOf()
          .unix(),
      };
    } else {
      return {
        ...value,
        startOf: moment
          .unix(get(value, "startOf"))
          .add(count, `${get(value, "type")}`)
          .startOf()
          .unix(),
        endOf: moment
          .unix(get(value, "endOf"))
          .add(count, `${get(value, "type")}`)
          .endOf()
          .unix(),
      };
    }
  };

  const prevHandler = () => {
    if (get(value, "type") === "day") {
      setValue({
        type: "day",
        startOf: moment
          .unix(get(value, "startOf"))
          .subtract(1, "day")
          .startOf("day")
          .unix(),
        endOf: moment
          .unix(get(value, "startOf"))
          .subtract(1, "day")
          .endOf("day")
          .unix(),
      });
    } else if (get(value, "type")) {
      setValue(dynamicFunc(value, 1, "prev"));
    } else {
      setValue(null);
    }
  };
  const nextHandler = () => {
    if (get(value, "type") === 1) {
      setValue({
        type: "day",
        startOf: moment
          .unix(get(value, "startOf"))
          .add(1, "day")
          .startOf("day")
          .unix(),
        endOf: moment
          .unix(get(value, "startOf"))
          .add(1, "day")
          .endOf("day")
          .unix(),
      });
    } else if (get(value, "type")) {
      setValue(dynamicFunc(value, 1, "next"));
    } else {
      setValue(null);
    }
  };

  return (
    <div className="date-filter" ref={ref}>
      <div className="date-filter-head">
        <span className="date-filter-head__button --prev" onClick={prevHandler}>
          <img src={ArrowRightIcon} alt="" />
        </span>
        <span
          className="date-filter-head__value"
          onClick={() => setIsVisible(true)}
        >
          {value ? dateConvert(value) : "Выберите дату"}
        </span>
        <span className="date-filter-head__button --next" onClick={nextHandler}>
          <img src={ArrowRightIcon} alt="" />
        </span>
      </div>
      <div
        className={`date-filter-menu ${
          dropdownPosition === "left" ? "--align-left" : ""
        } ${isVisible ? "--visible" : ""}`}
      >
        <div>
          {menuList.map((menuItem) => {
            return (
              <div
                key={menuItem.key}
                onClick={() => {
                  menuItem.onClick();
                  setIsVisible(false);
                }}
                className="date-filter-menu__item"
              >
                {menuItem.title}
              </div>
            );
          })}
        </div>
        <div className="date-filter-menu__datepickers">
          <Fields.NewDatePickerDefault
            placeholder="01.01.2023"
            format="dd.MM.yyyy"
            className=""
            customChange={true}
            value={startValue}
            handleChange={(date) => {
              onStartChange(date);
            }}
          />
          <span className={"fw-600 mr-10 ml-10"}>-</span>
          <Fields.NewDatePickerDefault
            placeholder="01.01.2023"
            format="dd.MM.yyyy"
            className=""
            customChange={true}
            value={endValue}
            handleChange={(date) => {
              onEndChange(date);
            }}
          />
          <button
            className="submit-button"
            onClick={() => {
              if (startValue || endValue) {
                changeHandler({
                  type: "interval",
                  startOf: moment(startValue).unix(),
                  endOf: moment(endValue).unix(),
                });
                setIsVisible(false);
              }
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default Index;
